module.exports = __webpack_public_path__ + "img/the-queens-fool.31e774d8.png";